<lib-addin-view *ngIf="view !== ''" [name]="view"></lib-addin-view>
